import { useForm } from '@mantine/form';

import type { EditInstPageData, EditTgPageData } from '../types';

export const useEditPageForm = (initialValues: EditTgPageData | EditInstPageData) =>
  useForm<EditTgPageData | EditInstPageData>({
    initialValues,
    validate: {
      name: (value) => (!value ? 'Name is required' : null),
    },
  });
